import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Checkbox,
  Button,
  message,
  notification,
} from 'antd'
import axios from 'axios' // Import axios for making HTTP requests
import qrcode from '../../StudentRegristrationDesign/JainBoardingNewQR.jpeg'
import { DonationAdd } from '../../ApiFile'
import { toast } from 'react-toastify'

const { Option } = Select

const Donation = () => {
  const [donationList, setDonationList] = useState("")
  const [isSecret, setIsSecret] = useState(false)
  const [file, setFile] = useState(null)
  const [amount, setAmount] = useState("")
  const [fname, setFname] = useState("")
  const [mname, setMname] = useState("")
  const [lname, setLname] = useState("")
  const [mob_no, setMob_no] = useState("")
  const [address, setAddress] = useState("")
  const [inputValue, setInputValue] = useState("")

  const downloadQRCode = () => {
    const link = document.createElement('a')
    link.href = qrcode
    link.download = 'JainBoardingNewQR.jpeg' // Set the file name
    link.click()
  }

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
  }

  const handleSubmit = async (values) => {
    if (!donationList) {
      toast.warn('Please Select A Donation For.')
      return
    }
    if (!amount) {
      toast.warn('Please Enter Amount.')
      return
    }
    if (!inputValue) {
      toast.warn('Please Enter Payment REF No.')
      return
    }
    if (!file) {
      notification.warning({
        message: 'Warning',
        description: 'Please Add Payment Image.',
      })
      return
    }

    const formData = new FormData()
    formData.append('fname', fname)
    formData.append('mname', mname)
    formData.append('lname', lname)
    formData.append('mob_no', mob_no)
    formData.append('address', address)
    formData.append('donation_for', donationList)
    formData.append('amount', amount)
    formData.append('tax_id', inputValue)
    if (file) {
      formData.append('file', file)
    }

    try {
      const response = await axios.post(DonationAdd, formData)

      if (response.data == "SAVED") {
         toast.success('Donation Submitted Successfully, Admin Will Contact You. ')
        // Clear form fields after submission
        setDonationList("")
        setIsSecret(false)
        setFile(null)
        setAmount("")
        setFname("")
        setMname("")
        setLname("")
        setMob_no("")
        setAddress("")
        setInputValue("")
        }
     
    } catch (error) {
      console.error('There was an error submitting the donation:', error)
      message.error('Failed to submit donation. Please try again.')
    }
  }

  return (
    <>
      <Navbar />
      <div>
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col>
            <h3 className="text-center">Donation</h3>
          </Col>
        </Row>
        <Row className="p-2 p-md-5">
          <Col span={12} xs={24} md={12} className="p-2 p-md-2">
            <h6
              style={{
                border: '2px solid gray',
                fontFamily: 'cursive',
                lineHeight: '23px',
              }}
              className="p-2 p-md-2 rounded"
            >
              <div className="text-center">
                <b>देणगी आवाहन</b>
              </div>
              <br />
              सस्नेह जय जिनेंद्र ! <br />
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;समाज धुरिणांनी स्थापन केलेल्या या दिगंबर जैन बोर्डिंग
              संकुलात राहून शिक्षण घेऊन आज असंख्य विद्यार्थी यशाच्या उत्तुंग
              शिखरावर विराजमान आहेत. आपणा सर्वांचा आम्हास सार्थ अभिमान आहे.
              स्थापनेपासून ते आजपर्यंत बोर्डिंगचा गुणवत्तेच्या दृष्टीने आलेख हा
              चढता राहिलेला आहे. अनेक आव्हानांचा सामना करीत आजच्या या माहितीच्या
              युगामध्येही आपली संस्था ग्रामीण भागातील विद्यार्थ्यांसाठी धडपडणारी
              अग्रगण्य संस्था आहे. मात्र आजमितीस गुणवत्तापूर्ण व सर्वसमावेशक
              सोयी सुविधा देताना अनेक अडचणी समोर आहेत. अनेक पायाभूत सुविधा
              निर्माण करताना तारेवरची कसरत करावी लागते आहे. शासनाकडून किंवा
              कोणत्याच प्राधिकरणाकडून आपणास कोणतीच मदत मिळत मिळत नाही. आज
              बदलत्या काळाची गरज म्हणून सर्वच बोर्डिंग, रूम्स अत्याधुनिक
              करण्याची गरज आहे. ही मोठी ‘खर्चिक’ बाब आहे. शिवाय अनेक खोल्यांची
              दुरुस्ती हा एक ज्वलंत प्रश्न आहे. बोर्डिंग च्या लौकिकाच्या
              दृष्टीने तसेच विद्यार्थ्यांच्या शास्वत विकासाच्या दृष्टीने; आता
              अमुलाग्र बदल करण्याची गरज आहे: प्रश्न आहे तो आर्थिक घडामोडींचा
              त्यासाठी शक्य ते सर्व प्रयत्न संस्था करतेच आहे.
              <br />
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
              विरचार्य बाबासाहेब कुचनुरे सरांनी गुंफलेली ही अतुट नात्यांची माळ
              आज अधिक घट्ट करण्याची गरज आहे. या दशक्रोशीतील समाजाच्या सर्वांगीण
              विकासात आजवर अग्रेसर राहिलेल्या या बोर्डिंग रथाची चक्रे अधिक
              गतीमान करण्याची गरज आहे. तरच ह्या स्पर्धेच्या युगात आपण तग धरू. आज
              अनेक व्यक्ती ज्या या संकुलात ज्ञानार्जन करून देश व आंतरराष्ट्रीय
              पातळीवर आपल्या कार्यकर्तृत्वाचा ठसा उमटवित आहेत. ही दैदिप्यमान
              परंपरा कायम ठेवण्यासाठी समाजातील सर्वच थरांतून मोठ्या आर्थिक
              मदतीची गरज आहे. आपल्यासारख्या सर्व माजी विद्यार्थ्याना
              र्सुवर्णसंधी आहे, या बोर्डिंग संकुलाच्या आधुनिक उन्नतीसाठी भरगोस
              आर्थिक मदत देऊन विकासाचे साक्षीदार होण्याची.तेव्हा संकल्प करूया
              माझे बोर्डिंग- माझी अस्मिता’ ही गोष्ट सार्थ करण्याचा. परत एकदा
              मागे फिरून ‘माझी कर्मभूमी’ पाहण्याचा व तिच्या विकासात योगदान
              देण्याचा. आम्हांस खात्री आहे समाज धुरिणांनी सुरु केलेला हा दातृत्व
              यज्ञ, आपणा सर्वांच्या बहुमूल्य योगदानामुळे अधिक ऊर्जेने सतत तेवत
              राहील ही दान पताका गगणाला भिडत सतत फडफडत राहील.
              <br /> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp; धन्यवाद
            </h6>
          </Col>
          <Col
            span={12}
            xs={24}
            md={12}
            className="p-2 pt-0 pt-md-0 p-md-5 pb-5 mb-5"
          >
            <Form layout="vertical" onFinish={handleSubmit}>
              <Row gutter={16}>
                <Col span={24}>
                  <b>
                    <b style={{ color: 'red' }}>Note: </b> For all donations 80
                    (G) exemption scheme will be applicable/सर्व देणगीसाठी 80
                    (G) सवलत लागू आहे.
                  </b>
                  <Form.Item label="Donation For" required className="mt-3">
                    <Select
                      defaultValue="Choose..."
                      value={donationList}
                      onChange={(value) => setDonationList(value)}
                    >
                      <Option value="">Choose...</Option>
                      <Option value="Annapurna Bhojan Fund">
                        Annapurna Bhojan Fund
                      </Option>
                      <Option value="Boarding Fund">Boarding Fund</Option>
                      <Option value="Adinath Mandir Fund">
                        Adinath Mandir Fund
                      </Option>
                      <Option value="Kagwade Hospital Fund">
                        Kagwade Hospital Fund
                      </Option>
                      <Option value="Pooja Dhruv Fund">Pooja Dhruv Fund</Option>
                      <Option value="Sangit Acadamy Fund">
                        Sangit Acadamy Fund
                      </Option>
                      <Option value="Scholarship Fund">Scholarship Fund</Option>
                      <Option value="Other">Other</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item>
                    <Checkbox
                      checked={isSecret}
                      onChange={(e) => setIsSecret(e.target.checked)}
                    >
                      Secret Donation (गुप्तदान)
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {!isSecret && (
                <>
                  <Row gutter={16}>
                    <Col span={24}>
                       <Form.Item label="First Name" required>
                    <Input
                      placeholder="Enter your first name"
                      value={fname}
                      onChange={(e) => setFname(e.target.value)}
                    />
                  </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item label="Middle Name" required>
                    <Input
                      placeholder="Enter your middle name"
                      value={mname}
                      onChange={(e) => setMname(e.target.value)}
                    />
                  </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item label="Last Name" required>
                    <Input
                      placeholder="Enter your last name"
                      value={lname}
                      onChange={(e) => setLname(e.target.value)}
                    />
                  </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={24}>
                       <Form.Item label="Postal Address" required>
                    <Input.TextArea
                      placeholder="Enter your postal address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Form.Item>
                    </Col>
                  <Col span={24}>
                    <Form.Item
                    label="Mobile Number"
                    rules={[
                      { required: true, message: 'Please enter your mobile number' },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: 'Mobile number must be exactly 10 digits',
                      },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      value={mob_no}
                      onChange={(e) => {
                        const val = e.target.value
                        if (/^\d*$/.test(val)) setMob_no(val)
                      }}
                      placeholder="Enter 10-digit mobile number"
                    />
                  </Form.Item>
                  </Col>
                  </Row>
                </>
              )}

              <div className="text-center mt-3">
                <img
                  src={qrcode}
                  style={{ height: '130px', width: '130px' }}
                  alt="QR Code"
                />
              </div>
              <div className="text-center">
                <Button
                  className="mt-3 mt-md-2"
                  style={{
                    background: 'rgb(57, 158, 161)',
                    color: 'white',
                    border: '0px',
                  }}
                  onClick={downloadQRCode}
                >
                  Download QR Code
                </Button>
              </div>

              <Row className="mt-md-2 mt-2 m-0 p-0">
                <Col md={8}>
                  <label>Account Name :</label>
                </Col>
                <Col md={16}>
                  <p>SHETH RAMDHANAJI DAVADA JAIN BOARDING SANGLI</p>
                </Col>
              </Row>

              <Row md={12} className="mt-md-2 mt-2">
                <Col md={8}>
                  <label>Account No :</label>
                </Col>
                <Col md={16}>
                  <p>120503130002085</p>
                </Col>
              </Row>

              <Row className="mt-md-2 mt-2">
                <Col md={8}>
                  <label>Bank Name/Branch :</label>
                </Col>
                <Col md={16}>
                  <p>SVC CO-OPERATIVE BANK LTD / SANGLI</p>
                </Col>
              </Row>

              <Row className="mt-md-2 mt-2">
                <Col md={8}>
                  <label>IFSC Code :</label>
                </Col>
                <Col md={16}>
                  <p>SVCB0000205</p>
                </Col>
              </Row>

              <Row className="mt-md-3 mt-2" style={{ display: 'flex' }}>
                <Col md={8}>
                  <label className="mt-2" htmlFor="Amount">
                    Pay Amount Rs:
                  </label>
                </Col>
                <Col md={16}>
                  <Input
                    type="number"
                    id="Amount"
                    style={{ height: '35px' }}
                    placeholder="Enter Amount"
                    value={amount}
                    name="amount"
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-md-3 mt-2" style={{ display: 'flex' }}>
                <Col md={8}>
                  <label className="mt-2" htmlFor="transactionId">
                    Payment Ref. No:
                  </label>
                </Col>
                <Col md={16}>
                  <Input
                    type="text"
                    id="transactionId"
                    style={{ height: '35px' }}
                    placeholder="UTR No/ Transaction Id"
                    value={inputValue}
                    name="tax_id"
                    onChange={(e) => setInputValue(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-md-3 mt-2" style={{ display: 'flex' }}>
                <Col md={8}>
                  <label className="mt-2" htmlFor="fileUpload">
                    Upload Payment Screenshot:
                  </label>
                </Col>
                <Col md={16}>
                   <input
                    type="file"
                    className="w-100"
                    onChange={handleFileChange}
                  />
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24} className="text-center py-4">
                  <Button type="primary" htmlType="submit">
                    Submit Donation
                  </Button>
                </Col>
              </Row>
              <Row>
                <b>
                  <b className="text-danger">Note: </b> Payment receipt will be
                  posted to your address after payment confirmation/पेमेंट
                  कन्फर्मेशन नंतर देणगी पावती आपल्या पत्त्यावर पाठवली जाईल.
                </b>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
      <Footer />
    </>
  )
}

export default Donation
